import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=83f7916e&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"
import style0 from "./Verification.vue?vue&type=style&index=0&id=83f7916e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f7916e",
  null
  
)

export default component.exports